/**
 * What stands in for a figure the trader has asked not to see — the portfolio's
 * eye toggle and «عدم نمایش مانده» both print this.
 *
 * One constant for both so a masked balance looks the same wherever it appears,
 * and so neither screen has to import the other's service to agree on it.
 */
export const MASKED_VALUE = '*****';
